import script from "./rec-quantity-history.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-quantity-history.vue?vue&type=script&lang=ts&setup=true"

import "./rec-quantity-history.vue?vue&type=style&index=0&id=2e0dd395&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0dd395"]])

export default __exports__